import { render, staticRenderFns } from "./WaratapobTransfer.vue?vue&type=template&id=25b3585e&"
import script from "./WaratapobTransfer.vue?vue&type=script&lang=js&"
export * from "./WaratapobTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports